import { useCallback, useEffect } from "react";
import { PersonService } from "../core/http/service/PersonService";

const photoCache: Map<string, string> = new Map();

const useFetchPhoto = (fileName: string | null, setValue: any) => {
    const fetchPhoto = useCallback(async () => {
        if (!fileName) return;

        if (photoCache.has(fileName)) {
            setValue(photoCache.get(fileName));
            return;
        }

        try {
            const service: PersonService = new PersonService();
            const photoUser: any = await service.getPhoto(fileName);

            const blob = new Blob([photoUser.data], {
                type: photoUser.headers["content-type"],
            });

            const image = URL.createObjectURL(blob);
            photoCache.set(fileName, image);
            setValue(image);
        } catch (error) {
            console.error("Erro ao buscar foto:", error);
        }
    }, [fileName, setValue]);

    useEffect(() => {
        if (fileName !== null && fileName !== undefined && fileName !== "") {
            fetchPhoto();
        }
    }, [fileName, fetchPhoto]);
};

export default useFetchPhoto;